import { Component, OnInit, Input } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { LoggerService } from 'src/app/services/Non-Master/logger.service';
import { tShoppingCartModel } from 'src/app/models/tShoppingCartModel';
import { tShoppingCartService } from 'src/app/services/tShoppingCart.service';

@Component({
  selector: 'app-shopping-cart-prepay-dialog',
  templateUrl: './shopping-cart-prepay-dialog.component.html',
  styleUrls: ['./shopping-cart-prepay-dialog.component.css']
})
export class ShoppingCartPrepayDialogComponent implements OnInit {

  TAG = 'ShoppingCartPrepayDialogComponent';

  @Input() selectedShoppingCartModel: tShoppingCartModel;

  editForm: FormGroup;
  submitted = false;


  constructor(
    private formBuilder: FormBuilder,
    public activeModal: NgbActiveModal,
    private log: LoggerService,
    private tShoppingCartService: tShoppingCartService,

  ) { }

  ngOnInit() {
    this.editForm = this.formBuilder.group({
      prepayValue: ['', [Validators.required]],
    });
  }

  cancel() {
    this.log.i(this.TAG, 'do cancel');
    this.activeModal.close('Close click');
  }

  get f() { return this.editForm.controls; }

  confirm() {
    // this.activeModal.dismiss();
    const prepayValue = this.editForm.get('prepayValue').value;
    this.log.i(this.TAG, 'do confirm value =' + prepayValue);
    this.submitted = true;

    if (this.editForm.valid) {

      this.selectedShoppingCartModel.bpFinalPrice = prepayValue;
      this.selectedShoppingCartModel.bpLineAmount = prepayValue;
      this.selectedShoppingCartModel.bpArAmount = prepayValue;

      this.log.i(this.TAG, 'value = ' + JSON.stringify(this.selectedShoppingCartModel));
      this.tShoppingCartService.updateData(this.selectedShoppingCartModel).subscribe(data => {

        this.log.i(this.TAG, 'value = ' + JSON.stringify(data));
        this.activeModal.close(data);

      });

    }

  }

}
